import {
  SelectionTagGroup,
  SelectionTagGroupItem,
} from '@synoptic/ui-kit/selection-tag/selection-tag-group.tsx';
import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';
import { formInfoTitle } from '@/components/streams/stream-form/stream-form.css.ts';
import {
  streamSelectionTagGroup,
  streamSelectionTagGroupContainer,
  streamSelectionTagGroupItem,
  selectionDescription,
  selectionTagGroupItemContent,
  selectionTitleContainer,
} from '@/components/streams/stream-form/stream-selection-tag-group/stream-selection-tag-group.css.ts';

export interface StreamSelectionItem {
  title: string;
  description: string;
  icon: ReactNode;
  value: string;
  disabled?: boolean;
}

interface StreamSelectionTagGroupItemProps {
  onValueChange: (value: string) => void;
  items: StreamSelectionItem[];
  value?: string;
  defaultValue?: string;
  label: string;
  className?: string;
}

export const StreamSelectionTagGroup: FC<StreamSelectionTagGroupItemProps> = ({
  items,
  onValueChange,
  value,
  label,
  defaultValue,
  className,
}) => {
  return (
    <div className={streamSelectionTagGroupContainer}>
      <h3 className={formInfoTitle}>{label}</h3>
      <SelectionTagGroup
        type={'single'}
        value={value}
        onValueChange={(value) => onValueChange(value)}
        defaultValue={defaultValue}
        className={clsx(streamSelectionTagGroup, className)}
      >
        {items.map((item) => (
          <StreamToggleGroupItem
            key={item.title}
            title={item.title}
            value={item.value}
            icon={item.icon}
            description={item.description}
            disabled={item.disabled}
          />
        ))}
      </SelectionTagGroup>
    </div>
  );
};

const StreamToggleGroupItem: FC<{
  title: string;
  description: string;
  icon: ReactNode;
  value: string;
  disabled?: boolean;
}> = ({ icon, title, description, value, disabled }) => (
  <SelectionTagGroupItem
    value={value}
    aria-label={`Tag ${value} stream`}
    className={streamSelectionTagGroupItem}
    disabled={disabled}
  >
    <div className={selectionTagGroupItemContent}>
      <div className={selectionTitleContainer}>
        {icon}
        {title}
      </div>
      <span className={selectionDescription}>{description}</span>
    </div>
  </SelectionTagGroupItem>
);
